export const GET_PROMO_REDDIT = 'GET_PROMO_REDDIT';
export const SET_PROMO_REDDIT = 'SET_PROMO_REDDIT';
export const ERROR_PROMO_REDDIT = 'ERROR_PROMO_REDDIT';